import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/profile")({
  beforeLoad: () => {
    throw redirect({ to: "/account/profile" });
  },
});
